import { useState } from "react";
import { MapModal, StaticMap } from "shared/components";
import { IAddress } from "shared/types";
import { MapContainer } from "Venues/components/Header/styles";

interface useVenueMapProps {
  title?: string;
  address?: IAddress;
}

export const useVenueMap = ({ title, address }: useVenueMapProps) => {
  const [showModal, setShowModal] = useState(false);

  const renderMapPreview = () => (
    <>
      {address?.staticImage && (
        <MapContainer as="button" type="button" onClick={() => setShowModal(true)}>
          <StaticMap
            coordinates={{
              longitude: address.longitude,
              latitude: address.latitude,
            }}
            image={address.staticImage}
            alt={`Static map of ${title}`}
            showOpenButton={true}
          />
        </MapContainer>
      )}
    </>
  );

  const renderMapModal = () => (
    <>
      {showModal && address && (
        <MapModal
          handleClose={() => setShowModal(false)}
          coordinates={{
            longitude: address.longitude,
            latitude: address.latitude,
          }}
        />
      )}
    </>
  );

  return { showModal, renderMapPreview, renderMapModal };
};
